import api from "../../../services/api";

const getMasterCareerTransisition = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    api.get(`/master/${id}/career-transisition`).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_MASTER_CAREER_TRANSISI", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getById = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    api.get("/master/career-transisition/" + id).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_MASTER_CAREER_TRANSISI", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const careerType = ({ commit }, name) => {
  return new Promise((resolve, reject) => {
    api.get(`/master/career-transisition/${name}/type`).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_CAREER_TRANSISI_TYPE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const careerReason = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    api.get(`/master/career-transisition/${id}/reason`).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_CAREER_TRANSISI_REASON", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const insert = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master/career-transisition", state.formInput).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const update = ({ state }, id) => {
  return new Promise((resolve, reject) => {
    api.put(`/master/career-transisition/${id}`, state.formInput).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const remove = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/career-transisition/" + state.id).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getCareerTransisiUser = ({ commit }, emp_no) => {
  return new Promise((resolve, reject) => {
    api.get(`/career-transisition/${emp_no}`).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESUSER", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateStatus = ({ state }, id) => {
  return new Promise((resolve, reject) => {
    api.put(`/fasilitas/status/${id}`, state.formInput).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateStatusResaign = ({ state }, id) => {
  return new Promise((resolve, reject) => {
    api.put(`/career-transisition/status/${id}`, state.formInput).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

export default {
  getMasterCareerTransisition,
  insert,
  update,
  getById,
  remove,
  careerType,
  getCareerTransisiUser,
  careerReason,
  updateStatusResaign,
  updateStatus
};
